<template>
  <div id="app">
    <div class="loading-overlay" v-if="loading.overlay">
      <div>
        <div>{{ loading.message }}</div>
        <div class="big-padding center">
          <img src="/static/img/loading.svg" />
        </div>
      </div>
    </div>
    <router-view></router-view>
    <notifications position="bottom right"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '../store/eventBus'

export default {
  name: 'App',
  computed: {
    ...mapState([
      'loading'
    ]),
  },
  data () {
    return {
      section: 'Head',
    }
  },
  mounted: function () {
    EventBus.$on('notify', function (props) {
      props.duration = 10000
      this.$notify(props)
    })
  },
  methods: {
    logout () {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)

      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }

      this.$router.push('/login')
    },
  },
}
</script>

<style lang="scss">
  @import "../scss/variables";
  @import "../scss/commons";

  body {
    font-family: 'DinRegular';
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'DinCondMedium';
  }

  .content .content-toolbar {
    text-align: right;
    margin-bottom: 2rem;
  }

</style>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>



// WEBPACK FOOTER //
// App.vue?1814bd8e